import { render, staticRenderFns } from "./allLogistics.vue?vue&type=template&id=67ef4abe&scoped=true"
import script from "./allLogistics.vue?vue&type=script&lang=js"
export * from "./allLogistics.vue?vue&type=script&lang=js"
import style0 from "./allLogistics.vue?vue&type=style&index=0&id=67ef4abe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef4abe",
  null
  
)

export default component.exports